exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".winner-carousel {\n  max-width: 1280px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n@media screen and (max-width: 959px) {\n  .winner-carousel {\n    margin: 0px;\n    padding: 0px;\n  }\n}\n", ""]);

// exports
